<template>
  <button class="button is-small is-text" @click.prevent="onClick">
    <span class="icon">
      <i v-if="open" class="mdi mdi-menu-up mdi-24px"></i>
      <i v-else class="mdi mdi-menu-down mdi-24px"></i>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: true
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  }
}
</script>